export default "__VITE_ASSET__G8j$TB$b__"